module.exports = __webpack_public_path__ + "img/60.f54852db.jpg";